const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export async function getTranslationsTable(URL, token, data) {
  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function searchTranslations(URL, token) {
  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: headers(token),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function getTranslationByKey(URL, token) {
  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: headers(token),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function getLanguages(URL, token) {
  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: headers(token),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function saveTranslation(URL, token, key, data) {
  return key
    ? updateTranslation(URL, token, key, data)
    : createTranslation(URL, token, data);
}

export async function createTranslation(URL, token, data) {
  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: headers(token),
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

async function updateTranslation(URL, token, key, data) {
  try {
    const response = await fetch(`${URL}/${encodeURIComponent(key)}`, {
      method: "PUT",
      headers: headers(token),
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function importTranslationExcel(URL, token, file) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await fetch(URL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.json(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function exportTranslationExcel(URL, token) {
  try {
    const response = await fetch(URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response.ok) {
      return {
        success: true,
        data: await response.blob(),
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}

export async function deleteTranslationByKey(URL, token) {
  try {
    const response = await fetch(URL, {
      method: "DELETE",
      headers: headers(token),
    });
    if (response.ok) {
      return {
        success: true,
      };
    } else {
      return {
        success: false,
        status: response.status,
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
}
